import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Navbar';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import Home from './components/pages/Home';
import Booking from './components/pages/Booking/Booking';
import Teambuilding from './components/pages/Booking/Teambuilding';
import CoffeeBasics from './components/pages/CoffeeBasics';
import SignUp from './components/pages/SignUp/SignUp';
import Gallery from './components/pages/Gallery';
// import ShoppingCart from "./components/pages/ShoppingCart/ShoppingCart";
import CheckoutSuccess from "./components/pages/ShoppingCart/CheckoutSuccess";
import OurStory from './components/pages/OurStory';
import Contact from './components/pages/Contact';
import TermsOfUse from './components/pages/TermsOfUse';
import TermsOfService from './components/pages/TermsOfService';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import Career from './components/pages/Career';
import CoffeeRoaster from './components/pages/CoffeeRoaster';
import Merch from './components/pages/Merch';
import OurCoffee from './components/pages/OurCoffee';
import OurMenu from './components/pages/OurMenu'; // legacy menu — kept in code, route disabled below
import CafeMenu from './components/pages/CafeMenu';
import OrderReceived from './components/pages/OrderReceived';
import AdminReviews from './components/pages/AdminReviews/AdminReviews';
import AdminOrders from './components/pages/AdminOrders/AdminOrders';
import AdminMenu from './components/pages/AdminMenu/AdminMenu';
import MyAccount from './components/pages/MyAccount/MyAccount';
import CartDrawer from './components/CartDrawer';
import Blog from './components/pages/Blog/Blog';
import BlogPost from './components/pages/Blog/BlogPost';

function App() {
  return (
    <Router>
      <CartProvider>
      <AuthProvider>
        <Navbar />
        <CartDrawer />
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='booking' element={<Booking />} />
          <Route path='team-building' element={<Teambuilding />} />
          <Route path='sign-up' element={<SignUp />} />
          <Route path='gallery' element={<Gallery />} />
          {/* <Route path="/cart" element={<ShoppingCart />} /> */}
          <Route path="/checkout-success" element={<CheckoutSuccess />} />
          <Route path='/our-story' element={<OurStory />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/terms-of-use' element={<TermsOfUse />} />
          <Route path='/terms-of-service' element={<TermsOfService />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/career' element={<Career />} />
          <Route path='/coffee-roaster' element={<CoffeeRoaster />} />
          <Route path='/merch' element={<Merch />} />
          <Route path='/our-coffee' element={<OurCoffee />} />
          {/* Legacy /our-menu route disabled — see new /menu route below.
              OurMenu component is still imported so /admin-menu's DEFAULT_MENU import keeps working. */}
          {/* <Route path='/our-menu' element={<OurMenu />} /> */}
          <Route path='/menu' element={<CafeMenu />} />
          <Route path='/order-received' element={<OrderReceived />} />
          <Route path='/my-account' element={<MyAccount />} />
          <Route path='/admin' element={<AdminReviews />} />
          <Route path='/admin-orders' element={<AdminOrders />} />
          <Route path='/admin-menu' element={<AdminMenu />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/blog/:slug' element={<BlogPost />} />
        </Routes>
      </AuthProvider>
      </CartProvider>
    </Router>
  );
}

export default App;